import React from 'react';
import {type TooltipFormulaItem} from '../../ForecastTooltipFormulaRenderer';
import {FinancialCategoryTooltip} from '../../../forecast-app/shared/components/tooltips/FinancialCategoryTooltip';
import {IntlShape} from 'react-intl';
import {useIntl} from 'react-intl';

type ProjectPortfolioReportTooltipProps = React.PropsWithChildren<{
	items: TooltipFormulaItem[];
	size?: string;
}>;

export const ProjectPortfolioReportTooltip = ({
	items,
	size,
	children,
}: ProjectPortfolioReportTooltipProps): React.JSX.Element => {
	if (!items || items.length === 0) {
		return <>{children}</>;
	}

	return (
		<FinancialCategoryTooltip items={items} size={size}>
			{children}
		</FinancialCategoryTooltip>
	);
};

export const createProjectPortfolioReportTooltip = (
	itemsFn: (formatMessage: IntlShape['formatMessage']) => TooltipFormulaItem[]
) => {
	return (props: Omit<ProjectPortfolioReportTooltipProps, 'items'>): React.JSX.Element => {
		const {formatMessage} = useIntl();
		return <ProjectPortfolioReportTooltip {...props} items={itemsFn(formatMessage)} />;
	};
};
